import type { Category, Id, Kink, KinklistDoc, Rating } from './types';

/** `ratings[0]`, the implicit "unset" rating. */
export function unsetRating(ratings: readonly Rating[]): Rating {
  const first = ratings[0];
  if (first === undefined) throw new Error('Invariant violated: a list needs at least one rating');
  return first;
}

export interface KinkLocation {
  category: Category;
  categoryIndex: number;
  kink: Kink;
  kinkIndex: number;
}

export function findKink(doc: KinklistDoc, kinkId: Id): KinkLocation | undefined {
  for (const [categoryIndex, category] of doc.categories.entries()) {
    const kinkIndex = category.kinks.findIndex((k) => k.id === kinkId);
    const kink = category.kinks[kinkIndex];
    if (kink) return { category, categoryIndex, kink, kinkIndex };
  }
  return undefined;
}

export function findCategory(doc: KinklistDoc, categoryId: Id): Category | undefined {
  return doc.categories.find((c) => c.id === categoryId);
}

export function findRating(doc: KinklistDoc, ratingId: Id): Rating | undefined {
  return doc.ratings.find((r) => r.id === ratingId);
}
